import { render } from "./SelectTravelPassDate.vue?vue&type=template&id=a98de21c&lang=pug"
import script from "./SelectTravelPassDate.vue?vue&type=script&lang=ts"
export * from "./SelectTravelPassDate.vue?vue&type=script&lang=ts"

import "./SelectTravelPassDate.vue?vue&type=style&index=0&id=a98de21c&lang=scss"
script.render = render

export default script